<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-form-group label-cols=1 label="Filter" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.CustName" placeholder="Customer Name" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-input-group >
                    <b-input-group-prepend><span class="p-2">Tgl. Delivery</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                  </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
          </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
            <template v-slot:cell(tanggal)="data">
              {{ data.item.tanggal | moment("DD MMM YYYY") }}
            </template>

            <template v-slot:cell(ttlItem)="data">
             <span v-if="(data.item.ttlItem)">{{data.item.ttlItem | numFormat}}</span>
            </template>
            <template v-slot:cell(ttlgross)="data">
             <span v-if="(data.item.ttlgross)">{{uanguser}} {{data.item.ttlgross | numFormat}}</span>
            </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
        </b-table>        
          <b-row>
          <b-col cols="6">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total | numFormat}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
              </select>
            </div>
          </b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
  </div>
</template>
<style lang="scss">
  .lku-charges {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import customerDO from "../../apis/bakerycustomerdelivery";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomorDeliv",
            thStyle: "width:100px",
            label: "DO Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "DO Date",
            sortable: true
          },
          {
            key: "CustCode",
            label: "Customer Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name (and Group)",
            sortable: true
          },
          {
            key: "ttlItem",
            tdClass: "text-right",
            label: "Jml. Item",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "ttlQty",
            tdClass: "text-right",
            label: "Jml. Qty",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "ttlgross",
            tdClass: "text-right",
            label: "Gross Amount",
            thStyle: "width:100px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'CustName',
        sortDesc: false,
        customer_group:''
      },
      lkuLoading:false,
      uanguser: this.$store.state.user.matauang,
    };
  },
  // props: {
  //   customer_group:{
  //     type: String,
  //     default: () => ''
  //   }
  // },
  props: [`formdata`],
  created: async function() {
      console.log("#this.formdata: ", this.formdata);
      this.tblData.customer_group=this.formdata.customer_group || '';
      this.tblData.customer_id=this.formdata.customer_id || '';
  },
  methods: {
    data: async function(ctx) {
      //this.tblData.customer_group = this.customer_group||'';
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await customerDO.listHeader(this.tblData);  
      console.log("#list customerDO: ", list);    
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={name:'', contact: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCust.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCust.refresh();
    }
  }
};
</script>
